import { Grid } from '@material-ui/core';
import React from 'react';
import { useLang } from '../../../../util/lang';
import AnswerGrid from './answerGrid';

const ReadOnlySpecialInstruction = ({ isInSummary = false, value = '' }) => {
    const getNotes = useLang('NewPatient');
    return (
        <Grid>
            <Grid>
                <p>{getNotes('prescriptionNotes.specialInstructionsDescription')}</p>
            </Grid>
            <section style={{ margin: '8px 18px' }}>
                <AnswerGrid value={value} isInSummary={isInSummary} />
            </section>
        </Grid>
    );
};

export default ReadOnlySpecialInstruction;
